import { render, staticRenderFns } from "./ChartsApex.vue?vue&type=template&id=fadf4f70&scoped=true&"
import script from "./ChartsApex.vue?vue&type=script&lang=js&"
export * from "./ChartsApex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadf4f70",
  null
  
)

export default component.exports